export interface BillingTypeClass {
    AccountBillingTypeId: number
    BillingCategoryId: number
    AccountId: number
    BillingType: string
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    MasterAccountBillingTypeId: number
    IsDisabled: boolean
    AccountBillingTypeGuidId: string
    IsDeleted: boolean
    isSelected: number
}

export const billingTypeInitialsForAdd = {
    BillingType: "",
    BillingCategoryId: 0,
    IsDisabled: false
}

export const billingTypeInitialsForUpdate = {
    AccountBillingTypeId: 0,
    BillingCategoryId:0,
    BillingCategory:"",
    BillingType: "",
    IsDisabled: false
}